import { Button, Modal, ModalContent, ModalFooter } from 'components/lib';
import React from 'react';

interface Props {
  title: string;
  onDismiss: () => void;
  onCancel: () => void;
  onConfirm: () => void;
  cancelButtonText?: string;
  confirmButtonText?: string;
}

const ConfirmModal: React.FC<Props> = ({
  children,
  title,
  onDismiss,
  onCancel,
  onConfirm,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
}) => {
  return (
    <Modal title={title} size="medium" onDismiss={onDismiss}>
      <ModalContent>{children}</ModalContent>
      <ModalFooter>
        <Button variant="tertiary" onClick={onCancel}>
          {cancelButtonText}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {confirmButtonText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
